"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var AjaxProvider_1 = __importDefault(require("@/functions/AjaxProvider"));
var GenericSnackbar_1 = __importDefault(require("../GenericSnackbar"));
var SettingUtils_1 = require("@/functions/SettingUtils");
var q_play_core_2 = require("@nordicscreen/q-play-core");
var AppEditor_module_css_1 = __importDefault(require("./AppEditor.module.css"));
var react_i18next_1 = require("react-i18next");
var inertia_1 = require("@inertiajs/inertia");
var FieldsComponent_1 = require("../FieldsComponent");
var SettingsSidebar = function (_a) {
    var appData = _a.appData, onUpdateSetting = _a.onUpdateSetting, onRemoveSetting = _a.onRemoveSetting;
    var dataProvider = (0, AjaxProvider_1.default)("/api");
    var logger = q_play_core_2.logManager.getLogger();
    var _b = (0, react_1.useState)([]), appDataSettings = _b[0], setAppDataSettings = _b[1];
    var _c = (0, react_1.useState)(false), showAllSettings = _c[0], setShowAllSettings = _c[1];
    var _d = (0, react_1.useState)(null), selectedSetting = _d[0], setSelectedSetting = _d[1];
    var _e = (0, react_1.useState)(null), unsavedSetting = _e[0], setUnsavedSetting = _e[1];
    var _f = (0, react_1.useState)({}), editedFields = _f[0], setEditedFields = _f[1];
    var _g = (0, react_1.useState)(false), snackbarOpen = _g[0], setSnackbarOpen = _g[1];
    var _h = (0, react_1.useState)(""), snackbarMessage = _h[0], setSnackbarMessage = _h[1];
    var _j = (0, react_1.useState)("success"), snackbarSeverity = _j[0], setSnackbarSeverity = _j[1];
    var showBackButton = selectedSetting !== null || showAllSettings;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    (0, react_1.useEffect)(function () {
        if (!selectedSetting && !unsavedSetting) {
            var normalizedSettings = Object.entries(appData.settings || {})
                .map(function (_a) {
                var key = _a[0], data = _a[1];
                var setting = (0, SettingUtils_1.createSettingFromData)(key, data);
                if (setting) {
                    setting.order = data.order || 100;
                }
                return setting;
            })
                .filter(function (s) { return s !== undefined; })
                .sort(function (a, b) { return (a.order || 100) - (b.order || 100); });
            if (JSON.stringify(normalizedSettings) !== JSON.stringify(appDataSettings)) {
                setAppDataSettings(normalizedSettings);
            }
        }
    }, [appData.settings, selectedSetting, unsavedSetting]);
    var handleSettingClick = function (setting) {
        setSelectedSetting(setting);
        setUnsavedSetting(null);
        var fields = (0, SettingUtils_1.extractFieldsFromSetting)(setting);
        if (setting instanceof q_play_core_1.AdvancedSelectSetting && setting.defaultValue) {
            fields.default = setting.defaultValue;
        }
        setEditedFields(fields);
    };
    var handleAddSetting = function (setting) {
        var baseKey = setting.key || (0, SettingUtils_1.getTypeString)(setting);
        var uniqueKey = baseKey;
        var counter = 1;
        while (appDataSettings.some(function (s) { return s.key === uniqueKey; })) {
            uniqueKey = "".concat(baseKey, "_").concat(counter++);
        }
        var initialFields = (0, SettingUtils_1.extractFieldsFromSetting)(setting);
        initialFields.key = uniqueKey;
        if (appData.type === "dataapp" &&
            setting instanceof q_play_core_2.StringSetting &&
            !(setting instanceof q_play_core_2.TextSetting) &&
            !(setting instanceof q_play_core_2.SelectSetting) &&
            !(setting instanceof q_play_core_2.PasswordSetting)) {
            initialFields.query_params = undefined;
        }
        var newSetting = (0, SettingUtils_1.recreateSettingInstance)(setting, initialFields);
        if (newSetting instanceof q_play_core_1.AdvancedSelectSetting && newSetting.defaultValue) {
            initialFields.default = newSetting.defaultValue;
        }
        setUnsavedSetting(newSetting);
        setSelectedSetting(newSetting);
        setEditedFields(initialFields);
        setShowAllSettings(false);
    };
    var handleBackClick = function () {
        setSelectedSetting(null);
        setUnsavedSetting(null);
        setEditedFields({});
        setShowAllSettings(false);
    };
    var handleFieldChange = function (field, value) {
        setEditedFields(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[field] = value, _a)));
        });
    };
    var confirmNewVersionCreation = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve) {
                    var userConfirmed = window.confirm(t("Saving this setting will create a new version of the app. Do you want to proceed?"));
                    resolve(userConfirmed);
                })];
        });
    }); };
    var handleSave = function () { return __awaiter(void 0, void 0, void 0, function () {
        var settingToSave, updated, formattedSetting, oldKey, newKey, updatedSettings, shouldCreateNewVersion, response, newVersionData, backendSettings, normalizedSettings, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    settingToSave = selectedSetting || unsavedSetting;
                    if (!settingToSave)
                        return [2 /*return*/];
                    updated = (0, SettingUtils_1.recreateSettingInstance)(settingToSave, editedFields);
                    updated = (0, SettingUtils_1.copyFieldsToSetting)(updated, editedFields);
                    formattedSetting = (0, SettingUtils_1.convertSettingToBackendFormat)(updated);
                    oldKey = settingToSave.key;
                    newKey = updated.key;
                    updatedSettings = __assign({}, appData.settings);
                    if (oldKey && oldKey !== newKey) {
                        delete updatedSettings[oldKey];
                    }
                    updatedSettings[newKey] = formattedSetting;
                    if (!appData.version_approved_at) return [3 /*break*/, 2];
                    return [4 /*yield*/, confirmNewVersionCreation()];
                case 1:
                    shouldCreateNewVersion = _b.sent();
                    if (!shouldCreateNewVersion) {
                        return [2 /*return*/];
                    }
                    _b.label = 2;
                case 2: return [4 /*yield*/, updateAppVersionSettings(updatedSettings)];
                case 3:
                    response = _b.sent();
                    newVersionData = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data;
                    if (appData.version_approved_at && (newVersionData === null || newVersionData === void 0 ? void 0 : newVersionData.version)) {
                        alert(t("A new version has been created and will now be loaded."));
                        inertia_1.Inertia.visit("/app-editor/".concat(appData.id, "?version=").concat(newVersionData.version));
                        return [2 /*return*/];
                    }
                    backendSettings = (newVersionData === null || newVersionData === void 0 ? void 0 : newVersionData.settings) || {};
                    normalizedSettings = Object.entries(backendSettings)
                        .map(function (_a) {
                        var key = _a[0], data = _a[1];
                        return (0, SettingUtils_1.createSettingFromData)(key, data);
                    })
                        .filter(function (s) { return s !== undefined; });
                    setAppDataSettings(normalizedSettings);
                    onUpdateSetting(updated, oldKey);
                    setSnackbarMessage(t("Setting saved successfully."));
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    setUnsavedSetting(null);
                    setSelectedSetting(null);
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    logger.error("Error saving settings:", error_1);
                    setSnackbarMessage(t("Failed to save setting."));
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleDelete = function (key) { return __awaiter(void 0, void 0, void 0, function () {
        var appId, version, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    appId = appData.id;
                    version = appData.version;
                    return [4 /*yield*/, dataProvider.deleteSetting(appId, version, key)];
                case 1:
                    _a.sent();
                    setAppDataSettings(function (prev) { return prev.filter(function (s) { return s.key !== key; }); });
                    onRemoveSetting(key);
                    setSnackbarMessage(t("Setting deleted successfully."));
                    setSnackbarSeverity("success");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _a.sent();
                    logger.error("Error deleting setting:", error_2);
                    setSnackbarMessage(t("Failed to delete setting."));
                    setSnackbarSeverity("error");
                    setSnackbarOpen(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var updateAppVersionSettings = function (settings) { return __awaiter(void 0, void 0, void 0, function () {
        var resource, payload, response, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    resource = "app-editor/app-versions/".concat(appData.id, "/").concat(appData.version, "/settings");
                    payload = { settings: settings };
                    return [4 /*yield*/, dataProvider.update(resource, {
                            id: "",
                            data: payload,
                            previousData: {},
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, response];
                case 2:
                    error_3 = _a.sent();
                    logger.error("Error updating settings on backend:", error_3);
                    throw error_3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var excludeDefaultIfNeeded = function (setting) {
        if (!setting)
            return false;
        var type = (0, SettingUtils_1.getTypeString)(setting);
        return type === "color" || type === "advanced_select" || type === "media_library";
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "".concat(AppEditor_module_css_1.default["settings-header"], " ns-font-family-bold") },
            react_1.default.createElement("div", { className: "".concat(AppEditor_module_css_1.default["settings-header-content"]) },
                showBackButton && (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faArrowLeft, style: {
                        fontSize: "20px",
                        cursor: "pointer",
                        position: "absolute",
                        left: "15px",
                    }, onClick: handleBackClick })),
                react_1.default.createElement("span", null, selectedSetting
                    ? "".concat(t("Editing"), " ").concat((0, SettingUtils_1.getTypeString)(selectedSetting) || t("App Settings"))
                    : t("App settings")))),
        !selectedSetting && !showAllSettings && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: AppEditor_module_css_1.default["settings-list"] }, appDataSettings.map(function (setting) { return (react_1.default.createElement("div", { key: setting.key, className: AppEditor_module_css_1.default["setting-item"], onClick: function () { return handleSettingClick(setting); }, onMouseEnter: function (e) {
                    e.currentTarget.style.border = "1px solid var(--primary-color)";
                }, onMouseLeave: function (e) {
                    e.currentTarget.style.border = "1px solid #ccc";
                }, "data-cy": "settingItem-".concat(setting.key) },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("strong", { style: { color: "var(--info-color)" }, "data-cy": "settingItemLabel-".concat(setting.key) }, setting.label),
                    react_1.default.createElement("p", { style: { color: "var(--info-color)" }, "data-cy": "settingItemType-".concat(setting.key) },
                        t("Type"),
                        ": ",
                        (0, SettingUtils_1.getTypeString)(setting))),
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, style: { color: "var(--error-color)", cursor: "pointer" }, onClick: function (e) {
                        e.stopPropagation();
                        handleDelete(setting.key);
                    }, "data-cy": "deleteSettingButton-".concat(setting.key) }))); })),
            react_1.default.createElement("div", { className: AppEditor_module_css_1.default["add-button-container"] },
                react_1.default.createElement(q_play_components_1.Button, { text: "+", style: { width: "91%" }, onClick: function () { return setShowAllSettings(true); }, "data-cy": "addSettingButton" })))),
        showAllSettings && (react_1.default.createElement("div", { className: AppEditor_module_css_1.default["available-settings-container"] }, SettingUtils_1.availableSettings.map(function (setting) { return (react_1.default.createElement("div", { key: setting.key, className: AppEditor_module_css_1.default["available-setting"], onClick: function () { return handleAddSetting(setting); }, onMouseEnter: function (e) {
                e.currentTarget.style.border = "1px solid var(--primary-color)";
            }, onMouseLeave: function (e) {
                e.currentTarget.style.border = "1px solid #ccc";
            }, "data-cy": "settingType-".concat((0, SettingUtils_1.getTypeString)(setting)) },
            react_1.default.createElement("strong", { style: { color: "var(--info-color)" }, "data-cy": "availableSettingLabel-".concat(setting.key) }, setting.label),
            react_1.default.createElement("p", { style: { margin: 0, fontSize: "14px", color: "var(--info-color)" }, "data-cy": "availableSettingDescription-".concat(setting.key) }, setting.description || t("No description")))); }))),
        selectedSetting && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: AppEditor_module_css_1.default["selected-setting-container"], "data-cy": "editSettingContainer" },
                excludeDefaultIfNeeded(selectedSetting)
                    ? (0, FieldsComponent_1.renderCommonFields)(editedFields, handleFieldChange, undefined, ["default"])
                    : (0, FieldsComponent_1.renderCommonFields)(editedFields, handleFieldChange),
                (0, FieldsComponent_1.renderSubclassFields)(selectedSetting, editedFields, handleFieldChange, appData.type)),
            react_1.default.createElement("div", { className: AppEditor_module_css_1.default["save-button-container"] },
                react_1.default.createElement(q_play_components_1.Button, { text: t("Save"), onClick: handleSave, style: { width: "100%" }, disabled: !editedFields.key || String(editedFields.key).trim() === "", "data-cy": "saveSettingButton" })))),
        react_1.default.createElement(GenericSnackbar_1.default, { open: snackbarOpen, onClose: function () { return setSnackbarOpen(false); }, message: snackbarMessage, severity: snackbarSeverity })));
};
exports.default = SettingsSidebar;
